import "../styles/default.scss";

import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import ModalBase from "../../ModalBase";
import LandingTypography from "../../../landingPage/components/LandingTypography";
import { SimpleButton } from "../../../landingPage/pages/Notifications/components/buttons/simpleButton";
import Close from "../../../landingPage/pages/Notifications/assets/close.svg";

@withTranslations
class PageSheet extends ModalBase {
  getClassName() {
    return "is-mobile-page-sheet";
  }

  getContent() {
    const {
      translate,
      title,
      hideModal,
      children,
      bottomChildren
    } = this.props;

    return (
      <LandingTypography className={"landing-typography_dark"}>
        <div className="page-sheet">
          <div>
            <div className={"flex justify-between mb-8 items-center"}>
              <strong className={"text-xl font-medium text-black"}>
                {title}
              </strong>
              <SimpleButton
                icon={Close}
                alt={translate("Close")}
                onClick={hideModal}
              />
            </div>
          </div>
          {children}
          {typeof bottomChildren === "function"
            ? bottomChildren({ hide: hideModal })
            : bottomChildren}
        </div>
      </LandingTypography>
    );
  }
}

export default PageSheet;
